import React from 'react'
import { Text, View } from 'react-native'
import { darkLightColor, disabledGray } from '../../../theme/colors'

interface Props {
  date: string
}

export const DescriptionControlService = ({ date }: Props) => {
  return (
    <View>
      <Text style={{ color: disabledGray }}>Registro pendiente: Ingreso control services</Text>
      <Text style={{ fontWeight: 'bold', color: darkLightColor }}>Fecha de formulario: {date}</Text>
    </View>
  )
}
